var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.cancelDate)?_c('div',{staticStyle:{"color":"red"}},[_c('span',{staticStyle:{"text-decoration":"line-through"}},[_vm._v(" "+_vm._s(_vm._f("dateFormat")(_vm.data,"DD.MM.YYYY"))+" ")])]):_c('div',[_vm._v(" "+_vm._s(_vm._f("dateFormat")(_vm.data,"DD.MM.YYYY"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }